export const TrUnChangebleTextField = (props) => {
    
    const {id, placeholder, value} = props;

    return (
        <>
            <tr><td><input type="text" id={id} placeholder={placeholder} value={value} readOnly className="border border-grey focus:outline-none cursor-not-allowed h-12 w-full"/></td></tr>
        </>
    );
};